var _rect, _ellipse, _ellipse2, _circle, _circle2, _circle3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#18181b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 270,
    rx: 270,
    ry: 105,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 7,
    transform: "rotate(-18 400 270)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 270,
    rx: 270,
    ry: 105,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 7,
    transform: "rotate(42 400 270)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 270,
    r: 48,
    fill: "#facc15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 190,
    r: 16,
    fill: "#f0abfc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 350,
    r: 16,
    fill: "#67e8f9"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#ede9fe",
    fontFamily: "sans-serif",
    fontSize: 48,
    fontWeight: 700
  }, "ORBIT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 22
  }, "CONTEXTUAL BANDIT COMPRESSION")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbit);
export default __webpack_public_path__ + "static/media/orbit.a0417ff824947e07508add51704e4094.svg";
export { ForwardRef as ReactComponent };